"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactUs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const Turnstile_1 = require("@src/components/elements/Turnstile");
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const contact_us_1 = require("@src/api/contact-us");
const email_1 = require("@src/helpers/form-validation-rules/email");
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("@src/types");
const turnstile_1 = require("@src/shared/turnstile");
const { Title } = antd_1.Typography;
const { TextArea } = elements_1.Input;
const maxMessageLength = 1000;
const ContactUs = () => {
    const [form] = antd_1.Form.useForm();
    const intl = (0, react_intl_1.useIntl)();
    const turnstileRef = (0, react_1.useRef)(null);
    const [isTurnstileSolved, setIsTurnstileSolved] = (0, react_1.useState)(false);
    const { mutateAsync, isLoading } = (0, useAppMutation_1.useAppMutation)(contact_us_1.contactUs, {
        onSuccess: () => {
            var _a;
            antd_1.notification.success({
                message: intl.formatMessage({ id: 'general.notice' }),
                description: intl.formatMessage({ id: 'contact.contact_us.sent_successfully' }),
            });
            form.resetFields();
            setIsTurnstileSolved(false);
            (_a = turnstileRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        },
        onError: error => {
            var _a;
            setIsTurnstileSolved(false);
            (_a = turnstileRef.current) === null || _a === void 0 ? void 0 : _a.reset();
            console.error(error);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'general.error',
                }),
                description: intl.formatMessage({
                    id: 'general.something_went_wrong',
                }),
            });
        },
    });
    const getTypePreset = () => {
        if (typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('type');
        }
    };
    const initialValues = {
        [types_1.ContactFormField.type]: getTypePreset() === 'recruitment'
            ? types_1.ContactFormFieldType.servicesRecruitment
            : types_1.ContactFormFieldType.servicesJobAdverts,
    };
    return ((0, jsx_runtime_1.jsxs)(elements_1.Holder, { marginVertical: true, "data-cy": "contact-us", children: [(0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { children: (0, jsx_runtime_1.jsx)(Title, { level: 2, type: "secondary", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.contact_us" }) }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, lg: 12, children: (0, jsx_runtime_1.jsx)(elements_1.Panel, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, { layout: "vertical", form: form, onFinish: mutateAsync, initialValues: initialValues, onValuesChange: changedValues => {
                                if (types_1.ContactFormField.turnstileToken in changedValues) {
                                    setIsTurnstileSolved(Boolean(changedValues[types_1.ContactFormField.turnstileToken]));
                                }
                            }, children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.ContactFormField.name, label: intl.formatMessage({
                                        id: 'contact.contact_us.name_and_surname',
                                    }), rules: [
                                        {
                                            required: true,
                                            message: intl.formatMessage({
                                                id: 'contact.validation.please_fill_name_and_surname',
                                            }),
                                        },
                                    ], children: (0, jsx_runtime_1.jsx)(StyledInput, { disabled: isLoading }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.ContactFormField.email, label: intl.formatMessage({
                                        id: 'contact.contact_us.email',
                                    }), rules: (0, email_1.getEmailRules)(intl), children: (0, jsx_runtime_1.jsx)(StyledInput, { type: "email", disabled: isLoading }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.ContactFormField.type, label: intl.formatMessage({
                                        id: 'contact.contact_us.type',
                                    }), children: (0, jsx_runtime_1.jsx)(StyledSelect, { options: [
                                            {
                                                value: 'SERVICES_JOB_ADVERTS',
                                                label: intl.formatMessage({
                                                    id: 'contact.type_job_adverts',
                                                }),
                                            },
                                            {
                                                value: 'SERVICES_RECRUITMENT',
                                                label: intl.formatMessage({
                                                    id: 'contact.type_recruitment',
                                                }),
                                            },
                                            {
                                                value: 'COOPERATION',
                                                label: intl.formatMessage({
                                                    id: 'contact.type_cooperation',
                                                }),
                                            },
                                            {
                                                value: 'PR_AND_MARKETING',
                                                label: intl.formatMessage({
                                                    id: 'contact.type_pr_and_marketing',
                                                }),
                                            },
                                            {
                                                value: 'SUPPORT',
                                                label: intl.formatMessage({
                                                    id: 'contact.type_support',
                                                }),
                                            },
                                        ] }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.ContactFormField.message, label: intl.formatMessage({
                                        id: 'contact.contact_us.message',
                                    }), rules: [
                                        {
                                            required: true,
                                            message: intl.formatMessage({
                                                id: 'contact.validation.please_fill_message',
                                            }),
                                        },
                                        {
                                            max: maxMessageLength,
                                            message: intl.formatMessage({
                                                id: 'contact.validation.message_max_length',
                                            }),
                                        },
                                    ], children: (0, jsx_runtime_1.jsx)(TextArea, { disabled: isLoading, showCount: true, maxLength: maxMessageLength, rows: 5 }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.ContactFormField.turnstileToken, validateTrigger: [], rules: [
                                        {
                                            required: true,
                                            message: intl.formatMessage({
                                                id: 'contact.contact_us.confirm_you_are_not_robot',
                                            }),
                                        },
                                    ], children: (0, jsx_runtime_1.jsx)(Turnstile_1.Turnstile, { ref: turnstileRef, siteKey: process.env.TURNSTILE_SITE_KEY, action: turnstile_1.TurnstileAction.contact }) }), (0, jsx_runtime_1.jsx)(SubmitRow, { children: (0, jsx_runtime_1.jsx)(SubmitButton, { htmlType: "submit", loading: isLoading, disabled: !isTurnstileSolved, children: intl.formatMessage({
                                            id: 'contact.contact_us.send',
                                        }) }) })] }) }) }) })] }));
};
exports.ContactUs = ContactUs;
const StyledInput = (0, styled_components_1.default)(elements_1.Input) `
	max-width: 300px;
`;
const StyledSelect = (0, styled_components_1.default)(antd_1.Select) `
	max-width: 300px;
`;
const SubmitRow = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	width: 100%;
`;
const SubmitButton = (0, styled_components_1.default)(elements_1.Button) `
	flex: 0 0 auto;

	&.ant-btn[disabled],
	&.ant-btn[disabled]:hover,
	&.ant-btn[disabled]:focus,
	&.ant-btn[disabled]:active {
		opacity: 0.5;
		cursor: not-allowed;
		pointer-events: auto;
	}
`;
